/*
 * @Author: cc
 * @Date: 2021-05-26 21:44:23
 * @LastEditTime: 2021-06-04 18:35:43
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\service\normalData.js
 * @Description: 常用数据集合
 */
angular.module('normalDataModule', []).factory('normalDataService', ['$q', 'trsHttpService', function ($q, trsHttpService) {
    let positions = ['普通员工', '副组长', '组长', '副主任', '主任'];
    let educations = ['专科', '本科', '研究生及以上'];
    let politics = ['党员', '预备党员', '共青团员', '群众'];
    let nations = ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'];
    let docgenre = [{
        'name': '无体裁',
        'value': '无体裁'
    }, {
        'name': '一版头条消息',
        'value': '一版头条消息'
    }, {
        'name': '其它版头条消息',
        'value': '其它版头条消息'
    }, {
        'name': '其它消息',
        'value': '其它消息'
    }, {
        'name': '调查类报道',
        'value': '调查类报道'
    }, {
        'name': '来信',
        'value': '来信'
    }, {
        'name': '重要评论文章',
        'value': '重要评论文章'
    }, {
        'name': '社论、特约评论员',
        'value': '社论、特约评论员'
    }, {
        'name': '通讯',
        'value': '通讯'
    }, {
        'name': '简讯',
        'value': '简讯'
    }, {
        'name': '本报评论员、署名评论',
        'value': '本报评论员、署名评论'
    }, {
        'name': '摄影作品',
        'value': '摄影作品'
    }, {
        'name': '短评（含编辑按、编后、小言论等）',
        'value': '短评（含编辑按、编后、小言论等）'
    }, {
        'name': '内参',
        'value': '内参'
    }, {
        'name': '新华社',
        'value': '新华社'
    }, {
        'name': '文摘',
        'value': '文摘'
    }];
    return {

        /**
         * [getNationals description] 获取民族信息
         * @return  {[type]}  [return description]
         */
        getNationals: function () {
            return nations;
        },

        /**
         * [getEducations description] 获取学历
         * @return  {[type]}  [return description]
         */
        getEducations: function () {
            return educations;
        },

        /**
         * [getPolitics description] 获取政治面貌
         * @return  {[type]}  [return description]
         */
        getPolitics: function () {
            return politics;
        },

        /**
         * [getProfessionals description] 获取职务 
         * @return  {[type]}  [return description]
         */
        getPositions: function () {
            return positions;
        },

        /**
         * [getProfessionals description] 获取职称
         * @return  {[type]}  [return description]
         */
        getProfessionals: function () {
            let defer = $q.defer();
            let params = {
                serviceid: 'zmy_performance',
                methodname: 'queryPositionalTitle'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                defer.resolve(data);
            });
            return defer.promise;
        },

        /**
         * [getPosts description] 获取岗位
         * @return  {[type]}  [return description]
         */
        getPosts: function () {
            let defer = $q.defer();
            let params = {
                serviceid: 'zmy_performance',
                methodname: 'queryStation'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                defer.resolve(data);
            });
            return defer.promise;
        },

        /**
         * [getDocGenre description] 获取稿件体裁
         * @return  {[type]}  [return description]
         */
        getDocGenre: function () {
            return docgenre;
        }
    };
},
]);
